export enum BaseTypes {
    string = 'string',
    number = 'number',
    object = 'object',
}
